import { render, staticRenderFns } from "./booklibrary.vue?vue&type=template&id=5ad752f9&scoped=true&"
import script from "./booklibrary.vue?vue&type=script&lang=js&"
export * from "./booklibrary.vue?vue&type=script&lang=js&"
import style0 from "./booklibrary.vue?vue&type=style&index=0&id=5ad752f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad752f9",
  null
  
)

export default component.exports